import "./agreement-content.js";

[...document.querySelectorAll(".top-categories a")].forEach((elm) => {
  if (elm.pathname === location.pathname) {
    elm.classList.add("text-active");
  }
});
